export default class UrlTemplateService {
	constructor(apiService) {
		this.apiService = apiService
	}

	addUrlTemplate(params) {
		return this.apiService.callPost('me/url_template', params)
	}

	updateUrlTemplate(id, params) {
		return this.apiService.callPost('me/url_template/' + id, params)
	}

	deleteUrlTemplate(id, params) {
		return this.apiService.callDelete('me/url_template/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/UrlTemplateService.js